var InputBase = require('../base');
var DatePicker = InputBase.extend( {
    create: function( inputOptions, $container ) {
        var self = this;
        var $picker = $( '<input type="text">' )
                .prop('readonly', !inputOptions.manual)
                .appendTo( $container )
                .on( 'focus', function() {
                    self.trig( 'Focus' );
                })
                .on( 'change', function() {
                    self.trig( 'Change' );
                } )
                .on( 'blur', function() {
                    self.trig( 'Blur' );
                } );

        inputOptions.dateFormat = inputOptions.dateFormat || 'yy-mm-dd';

        inputOptions.onSelect = function(dateText) {
            self.trig( 'Change' );
            $picker.blur();
        };

        $picker.datepicker( inputOptions );

        $('<span class="fa fa-calendar">')
            .appendTo( $container );

        return $picker;
    }
} );

module.exports = DatePicker;


/*****************
 ** WEBPACK FOOTER
 ** ./src/input-factory/datepicker/index.js
 ** module id = 13
 ** module chunks = 0
 **/